<template>
    <div>
        <Spin v-if="tkLoading" size='large'></Spin>
        <div v-else>
            <Row :gutter="60" style="width:100%" v-if="myExamList.length">
                <i-col :md="12" :lg="8" :xl="8" :xxl="6" :style="{ marginBottom: '30px' }" v-for="(item, i) in myExamList" :key="i">
                    <div class="test-paper">
                        <div class="left-top">{{item.examPaperType ? '正式考试' :'模拟考试'}}</div>
                        <div class="time"><Icon type="ios-time" color="#FF9D00" size="18"/>耗时：{{ item.costTime }}</div>
                        <div class="title" :title="item.examPaperName">{{ item.examPaperName }}</div>
                        <div class="count-info">
                            <span class="ct">得分：{{ item.totalScore }}分</span><span class="center">|</span><span class="as">及格:{{ parseInt(item.passingScore) }}分</span>
                        </div>
                        <Button v-if="item.completionStatus" class="btnActive" type="primary" shape="circle" size="large" @click="toPaperDetail(item.examPaperParticipateSummaryId, item.examPaperName)">查看详情</Button>
                        <Button v-else class="btnActive" type="primary" shape="circle" size="large" @click="toExam(item)">去考试</Button>
                        <div class='seal' v-if="item.completionStatus!==0 && item.totalScore < Number(item.passingScore)"><img src="@/assets/noPass.png" alt=""/></div>
                        <div class='seal' v-if="item.totalScore >= Number(item.passingScore)"><img src="@/assets/pass.png" alt=""/></div>
                    </div>
                </i-col>
            </Row>
            <nullPage v-else>
                <div slot="tipsText">暂无考试记录，赶快去测试测试吧！</div>
            </nullPage>
        </div>
        <Drawer title="试卷详情" closable v-model="modalPaper" width="90%" draggable>
            <Spin size='large' v-if="loading"></Spin>
            <div v-else>
                <Button type="primary" :loading="submitLoading" @click="toPrint">打印</Button>
                <div ref="print" class="recordImg" id="print">
                    <!-- <div class="no-print">不需要打印的内容</div> -->
                    <div class="do-not-print-div">
                        <div class="topicType_item">
                            <div class="line_gloge"></div>
                            <div class="dec_top_paper">
                                <div> 耗时：{{ testPaperData.costTime }}</div>
                                <div>得分：{{ testPaperData.totalScore }}分</div>
                            </div>
                            <div class="test_paper">
                                <div class="title_paper">{{ currExamPaperName }}</div>
                            </div>
                            <div v-for="(item,index) in detailsData" :key="index">
                                <div class="topic_type">{{ detailsIndex[index] }}、 {{ item.titleName }}题。（共{{ item.scoreAll }}分）</div>
                                <div class="topic_list">
                                    <div class="topic_item" v-for="(itemTopic, indexs) in item.modelList" :key="indexs">
                                        <div class="topic_stem">
                                            <p>{{ indexs+1 }}、</p>
                                            <!-- <span>（{{ itemTopic.score }}分）</span> -->
                                            <div>
                                                <mavonEditor 
                                                    :boxShadow="false" 
                                                    styleEditor="min-height: 20px;width: 100%;" 
                                                    :content="itemTopic.title" 
                                                    :subfield="false" 
                                                    :toolbarsFlag="false" 
                                                    previewBackground="#fff"
                                                    defaultOpen="preview" 
                                                />
                                            </div>
                                        
                                            <div class="top_answer">
                                                <div>{{itemTopic.yourAnswer}}</div>
                                                <Icon type="md-checkmark" size='26' color='green' v-if="itemTopic.rightStatus ==1"/>
                                                <Icon type="md-close" size='26' color='red' v-else/>
                                                <div v-if="itemTopic.topicType == 4 && itemTopic.rightStatus!==1">
                                                    正确答案：<div v-for="(item,i) in itemTopic.answerList" :key="i" style="margin-left:20px">{{item}}</div>
                                                </div>
                                                <div v-if="itemTopic.topicType !== 4 && itemTopic.rightStatus!==1">正确答案：{{itemTopic.answer}}</div>
                                            </div>
                                        </div>
                                        
                                        <div class="options_list" v-if="itemTopic.optionsList && itemTopic.optionsList.length > 0">
                                            <div class="options_item" v-for="(itemOptions, indexx) in itemTopic.optionsList" :key="indexx">
                                                <p>{{ ['A','B','C','D','E','F'][indexx] }}: </p>
                                                <div style="width: 200px;">
                                                    <mavonEditor 
                                                        :boxShadow="false" 
                                                        styleEditor="min-height: 20px;width: 200px;" 
                                                        :content="itemOptions" 
                                                        :subfield="false" 
                                                        :toolbarsFlag="false" 
                                                        previewBackground="#fff"
                                                        defaultOpen="preview" 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="questions_list" v-if="itemTopic.topicType == 5">答案：</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </Drawer>
    </div>
</template>
<script>
import nullPage from './components/nullPage.vue'
import { TOPICTYPE } from '@/libs/config.js';
import util from '@/libs/util'
import mavonEditor from './components/mavonEditor';
export default {
    components:{ mavonEditor, nullPage },
    props:{
        myExamList:{
            type: Array,
            default: []
        },
        tkLoading:{
            type: Boolean,
            default:false
        }
    },
    created(){
        this.userInfo = util.localGet('userInfo')
    },
    data(){
        return{
            loading: false,
            userInfo: {},
            modalPaper: false,
            submitLoading: false,
            testPaperData: {},
            printingCode: '',
            detailsData: null,
            paperDetails: false,
            detailsIndex: ['一','二','三','四','五','六','七','八'],
            currExamPaperName: ''
        }
    },
    methods:{
        // 处理答案函数
        handleAnswerProcessing(data){
            let optionsSet = ['optionsA','optionsB','optionsC','optionsD','optionsE','optionsF'];
            let optionsList = [];
            // 1: '单选',
            // 2: '多选',
            // 3: '判断',
            // 4: '填空',
            // 5: '主观',
            // 6: 'scratch程序'
            switch (Number(data.questionType)) {
                case 1:
                    for (const key in data) {
                        if(optionsSet.indexOf(key) != -1){
                            optionsList.push(decodeURIComponent(data[key]));
                        }
                    }
                break;
                case 2:
                    for (const key in data) {
                        if(optionsSet.indexOf(key) != -1){
                            optionsList.push(decodeURIComponent(data[key]));
                        }
                    }
                break;
                case 3:
                break;
                case 4:
                
                break;
                case 5:
                break;
                case 6:
                break;
            };
            return optionsList;
        },
        async toPaperDetail(id, name){
            this.modalPaper = true
            this.currExamPaperName = name
            let params = {
                userId: this.userInfo.id,
                examPaperParticipateSummaryId: id
            }
            util.md5Encryption(params)
            this.loading = true
            const result = await this.postTKRequest('/v1/getExamPaperAnswer',params,true)
            this.loading = false
            if(result.success){
                let keyList = [];
                let topicList = [];
                const { questionAnswerList } = result.result;

                questionAnswerList.forEach(res => {
                    if(keyList.indexOf(res.question.questionType) == -1){
                        keyList.push(res.question.questionType);
                    }
                });
                keyList.forEach(res => {
                    let listTopic = questionAnswerList.filter(v => { return v.question.questionType == res })
                    topicList.push({
                        titleName: TOPICTYPE[res],
                        modelList: listTopic.map(el => {

                            return {
                                scoreValue: el.scoreValue,
                                topicType: res,
                                title: decodeURIComponent(el.question.title),
                                optionsList: this.handleAnswerProcessing(el.question),
                                rightStatus: el.rightStatus,
                                yourAnswer: el.yourAnswer,
                                answer: el.question.answer,
                                answerList : [decodeURIComponent(el.question.answerA),el.question.answerB?decodeURIComponent(el.question.answerB):'',el.question.answerC?decodeURIComponent(el.question.answerC):'',el.question.answerD?decodeURIComponent(el.question.answerD):'',el.question.answerE?decodeURIComponent(el.question.answerE):''],
                                answerCount: el.question.answerCount,
                            }
                        }),
                        scoreAll: (() => {
                            let sum = 0
                            for (var i in listTopic) {
                                sum += parseInt(listTopic[i].score) 
                            }
                            return sum
                        })(),
                        scoreValueAll: (() => {
                            let sum = 0
                            for (var i in listTopic) {
                                sum += parseInt(listTopic[i].scoreValue) 
                            }
                            return sum
                        })()
                    })
                });
                // this.paperDetails = true;
                this.detailsData = topicList;
                this.testPaperData = result.result;
                
            };
        },
        toPrint(){
            this.$print(this.$refs.print);
        },
        toExam(item){
            this.$router.push({
                name:'simulationTestDetail',
                query: {examPaperId:item.id, summaryId:item.examPaperParticipateSummaryId}
            })
        }
    }
}
</script>
<style lang="less" scoped>
/deep/ .ivu-spin-large{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.test-paper {
    position: relative;
  display: flex;
  flex-direction: column;
  height: 255px;
  background: url('../../assets/item.png') no-repeat;
  background-size: 100% 100%;
  transition: all .6s;
  .left-top {
    margin-left: 15px;
    margin-top: 15px;
    font-size: 14px;
    transition: all .6s;
  }
  .time {
    position: absolute;
    top: 45px;
    right: 50px;
    transition: all .6s;
    /deep/ .ivu-icon{
      margin-right: 5px;
    }
  }
  .top {
    height: 140px;
    border: 1px solid #ccc;
    border-radius: 6px;
    transition: all .6s;
  }
  .title {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    padding: 0 10px;
    overflow: hidden;
    transition: all .6s;
  }
  .count-info{
    position: absolute;
    top: 140px;
    left: 50%;
    display: inline-flex;
    justify-content: space-around;
    width: 200px;
    transform: translateX(-50%);
    transition: all .6s;
    .center,.as,.ct{
      position: absolute;
      top: 0;
    }
    .center{
      left: 50%;
      transform: translateX(-50%);
    }
    .ct{
      left: 0px;
    }
    .as{
      right: 0;
    }
    
  }
  /deep/ .ivu-btn {
    position: absolute;
    top: 180px;
    left: 50%;
    font-size: 14px;
    padding: 0 20px;
    outline: none;
    border-color: #ff9d00;
    transform: translateX(-50%);
    background-color: #fff;
    color: #ff9d00;
    transition: all .6s;
  }
}
.test-paper:hover {
  background: url('../../assets/itemActive.png') no-repeat;
  background-size: 100% 100%;
  .left-top,
  .time,
  .title,
  .count-info {
    color: #fff;
    /deep/ .ivu-icon {
      color: #fff !important;
    }
  }
  .title{
    border-bottom: 1px solid #fff;
  }
  /deep/ .ivu-btn {
    background-color: #fff;
    color: #ff9d00;
    border-color: #fff;
  }
}
// @import './style/cardCommon.less.less';
.top_paper, .paper_info, .answer_analysis{
    display: flex;
    justify-items: flex-start;
    align-items: center;
}
.top_paper{
    margin-top: 20px;
}
.dec_top_paper{
    position: absolute;
    top: 15px;
    right: 50px;
}
.line_gloge{
    height: 1px;
    width: 100%;
    background: #ccc;
    margin-top: 25px;
}
.title_paper{
    font-size: 22px;
    font-weight: 600;
    width: 100%;
    text-align: center;
    margin: 40px 0 60px;
}
.paper_info{
    justify-content: space-between;
}
.answer_analysis{
    margin-bottom: 28px;
}
.answer_analysis p{
    font-size: 16px;
    color: #777;
    margin-left: 20px;
}

.topic_type{
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 18px;
}
.topic_list{
    padding-left: 30px;
    margin-bottom: 50px;
}
.topicType_item{
    position: relative;
    width: 100%;
    height: 100%;
    padding:0 20px 20px 20px;
    // column-count: 2;
    // column-gap: 0; 
}
.topic_stem, .options_list{
    display: flex;
    justify-items: flex-start;
    // align-items: center;
    align-items: flex-start;
    // width: 95%;
    width: 100%;
    min-height: 20px;
}
.topic_stem{
    margin-bottom: 15px;
}
.options_list{
    flex-wrap: wrap;
    padding-left: 30px;
}
.topic_stem p{
    margin-top: 2px;
    // margin-bottom: 16px;
}
.topic_stem div{
    // width: 95%;
    // width: 100%;
}
/deep/ .exhibition{
    width: 100%;
}
.topic_stem span{
    min-width: 60px;
    // margin-bottom: 16px;
}
.options_item{
    display: flex;
    justify-items: flex-start;
    align-items: center;
    flex-wrap: wrap;
    min-width: 300px;
    margin-right: 30px;
}
.options_item p{
    min-width: 20px;
    margin-bottom: 16px;
    margin-right: 5px;
}
.topic_item{
    position: relative;
    margin-bottom: 30px;
    .top_answer{
        // position: relative;
        // top: 0;
        // right: 20%;
        // z-index: 9999;
        display: flex;
        // align-items: center;
        min-width: 100px!important;
        justify-content: space-between;
        margin-left: 30px;
        font-size: 18px;
    }
}

.topic_item:last-child{
    margin-bottom: 0;
}
.questions_list{
    min-height: 180px;
    // width: 95%;
    width: 100%;
    background: #fff;
}
.seal{
    position: absolute;
    top: 40px;
    right: 5px;
    img{
        width: 60px;
        height: 60px;
    }
}
/deep/ .ivu-spin{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/practise/myExam.vue